import { render, staticRenderFns } from "./MultiPartsCopyButton.vue?vue&type=template&id=0fc102d0&scoped=true&"
import script from "./MultiPartsCopyButton.vue?vue&type=script&lang=js&"
export * from "./MultiPartsCopyButton.vue?vue&type=script&lang=js&"
import style0 from "./MultiPartsCopyButton.vue?vue&type=style&index=0&id=0fc102d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc102d0",
  null
  
)

export default component.exports